import { addGlobalLiveEventListener } from '../utils';
import { hidePreloader, showPreloader } from "./preloader";
import scrollToElement from "./scrollto";
import EventBus from "../events/EventBus";
import { getHeight, isSticky } from "./headroom";
const isFilterPage = !!document.getElementById('filter-app');
if (document.querySelector('.pagination[data-ajax="true"]') || document.querySelector('.catalog_items')) {
    addGlobalLiveEventListener('click', ['.btn--load-more', '.pagination__link'], onClick);
    if (!isFilterPage) {
        history.replaceState(buildState(), document.title);
    }
    fixViewport();
    fixViewport(300);
    if (!isFilterPage) {
        window.addEventListener('popstate', onPopState);
    }
}
async function onClick(event) {
    const pagerElement = document.querySelector('.pagination');
    if (pagerElement?.dataset.ajax !== 'true') {
        return;
    }
    const currentPage = parseInt(pagerElement.dataset.currentPage || '1');
    const direct = pagerElement.dataset.direct === 'true';
    const filter = pagerElement.dataset.filter === 'true';
    const url = direct && pagerElement.dataset.baseUrl ? pagerElement.dataset.baseUrl : '';
    let page;
    const isMoreButton = event.target.classList.contains('btn--load-more');
    showPreloader();
    event.preventDefault();
    if (isMoreButton) {
        page = currentPage + 1;
    }
    else if (event.target.dataset.page) {
        page = parseInt(event.target.dataset.page);
    }
    else {
        page = parseInt(event.target.innerText.trim());
    }
    if (filter) {
        EventBus.emit('filter:page', { page, isMoreButton });
        return;
    }
    if (!direct && url === '') {
        console.error('bad pager configuration', { currentPage, direct, filter, url });
        return;
    }
    const params = direct ? {} : window.filterStatus;
    const html = await fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        body: getFormData(page, params)
    }).then((response) => response.text())
        .catch((error) => {
        hidePreloader();
        window.Sentry.captureException(error);
    });
    if (html) {
        updateHtml(html, !isMoreButton, undefined, isMoreButton);
        pushState(html, page);
    }
}
function onPopState(event) {
    if (!event.state || !event.state.html) {
        return;
    }
    updateHtml(event.state.html, false, event.state.pager);
    fixViewport();
}
function fixViewport(delay = 0) {
    setTimeout(() => {
        const catalogItems = document.querySelector('.catalog_items');
        const boundingRect = catalogItems.getBoundingClientRect();
        if (boundingRect.bottom < 300) {
            scrollToElement(catalogItems, -20);
        }
    }, delay);
}
function pushState(html, page) {
    const query = new URLSearchParams(document.location.search);
    if (isFilterPage) {
        return;
    }
    query.delete('page');
    if (page > 1) {
        query.append('page', page.toString());
    }
    history.pushState(buildState(html), document.title, query.toString() ? `?${query.toString()}` : './');
}
function buildState(html) {
    return {
        html: html ? html : document.querySelector('.catalog_items')?.innerHTML.trim(),
        pager: html ? undefined : document.querySelector('.pagination')?.parentElement?.outerHTML.trim(),
    };
}
export function updateHtml(html, scroll, pagerHtml, append) {
    const catalogItems = document.querySelector('.catalog_items');
    if (!catalogItems) {
        return;
    }
    if (append) {
        catalogItems.insertAdjacentHTML('beforeend', html);
    }
    else {
        EventBus.emit('products:unload');
        catalogItems.innerHTML = html;
    }
    if (typeof pagerHtml === 'string') {
        updatePagerHtml(pagerHtml);
    }
    else {
        const paginationWrapper = catalogItems.querySelector('[data-pagination]');
        if (paginationWrapper) {
            paginationWrapper.remove();
            updatePagerHtml(paginationWrapper.firstElementChild);
        }
    }
    if (scroll) {
        scrollToElement(catalogItems, -20 - (isSticky() ? getHeight() : 0));
    }
    EventBus.emit('products:load');
    hidePreloader();
}
export function updatePagerHtml(pagerHtml) {
    const catalogItems = document.querySelector('.catalog_items');
    let pager;
    if (!catalogItems) {
        return;
    }
    if (typeof pagerHtml === 'string') {
        const el = document.createElement('div');
        el.innerHTML = pagerHtml.trim();
        pager = el.firstElementChild;
    }
    else if (pagerHtml) {
        pager = pagerHtml;
    }
    const wrap = catalogItems.parentElement.parentElement;
    let paginationWrapper = wrap.querySelector('[data-pagination]');
    if (paginationWrapper) {
        paginationWrapper.innerHTML = '';
    }
    else {
        paginationWrapper = document.createElement('div');
        paginationWrapper.classList.add('page-block__pagination');
        paginationWrapper.dataset.pagination = '';
        wrap.appendChild(paginationWrapper);
    }
    if (pager) {
        paginationWrapper.appendChild(pager);
    }
    else {
        paginationWrapper.remove();
    }
}
function getFormData(page, params) {
    const data = {
        page,
        filter: JSON.stringify(params),
    };
    const formData = new FormData();
    for (const name in data) {
        if (data.hasOwnProperty(name)) {
            formData.append(name, data[name]);
        }
    }
    return formData;
}
